<template>
  <v-dialog v-model="showWelcomeDialog" contained max-width="400" :persistent="!dataLoaded" class="custom-dialog">
    <v-card rounded="lg">
      <template #text>
        <div class="text-center pt-4">
          
          <v-progress-circular
              v-if="shouldShowLoading"
              indeterminate
              color="primary"
              size="x-large"
              class="mb-4"
              @dblclick="copyQueryString"
          />
          <v-avatar
            v-else
            class="mb-4"
            color="success"
            size="x-large"
            variant="tonal"
            icon="mdi-check"
            @dblclick="copyQueryString"
            style="cursor: pointer"
          ></v-avatar>

          <div class="font-weight-bold mb-2">
            {{ $t('welcomeMessage', { projectName: projectName }) }}
          </div>

          <div class="text-body-2 text-medium-emphasis mb-6"></div>

          <v-progress-linear
            v-if="shouldShowLoading"
            :model-value="progressValue"
            color="primary"
            height="2"
            class="mb-4"
            stream
          />
        </div>
      </template>
    </v-card>
  </v-dialog>

  <!-- Toast Notification -->
  <v-snackbar
    v-model="showToast"
    :timeout="2000"
    color="success"
    location="top"
  >
    Dev mode
    
    <template v-slot:actions>
      <v-btn
        color="white"
        variant="text"
        @click="showToast = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { computed, watch, ref } from 'vue';
import { useAppStore } from '@/stores/app';
import { useSettingsStore } from '@/stores/settings';

const appStore = useAppStore();
const settingsStore = useSettingsStore();
const showToast = ref(false);

const showWelcomeDialog = computed(() => appStore.getShowWelcomeDialog);

const projectName = computed(() => settingsStore.getProjectName);
const dataLoaded = computed(() => appStore.getDataLoaded);

// Props for progress tracking
const props = defineProps({
  apiProgress: {
    type: Number,
    required: true
  },
  totalApiRequests: {
    type: Number,
    required: true
  },
  withLoading: {
    type: Boolean,
    default: true
  }
});

// Compute whether to show loading elements
const shouldShowLoading = computed(() => {
  return props.withLoading;
});

// Compute the progress percentage
const progressValue = computed(() => {
  return (props.apiProgress / props.totalApiRequests) * 100;
});

// Function to copy query string to clipboard
const copyQueryString = async () => {
  try {
    const queryString = window.location.search;
    await navigator.clipboard.writeText(queryString);
    showToast.value = true;
  } catch (err) {
    console.error('Failed to copy query string:', err);
  }
};

watch(dataLoaded, (newValue) => {
  if (newValue) {
    showWelcomeDialog.value = false;
  }
});

watch(showWelcomeDialog.value, (newValue) => {
  if (newValue) {
    showWelcomeDialog.value = false;
  }
});

</script>

<style>
.v-dialog .v-overlay__content {
  top: 20vh !important;
}
</style>